import { Navigate } from "react-router-dom";
import { checkIfAuthenticated } from "../utils/utils";
import { useEffect, useState } from "react";

const RequireAuth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    checkIfAuthenticated()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const authStatus = checkIfAuthenticated();
      if (authStatus !== isAuthenticated) {
        setIsAuthenticated(authStatus);
      }
    }, 300000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  if (!checkIfAuthenticated()) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RequireAuth;
